"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ScreenP2pConfirmRentAmountAnalyticsEvent = exports.ScreenP2pConfirmAddressAnalyticsEvent = exports.P2pUpdateRentCtaClickedAnalyticsEvent = exports.P2pUpdatePropertyCtaClickedAnalyticsEvent = exports.P2pUpdateAddressCtaClickedAnalyticsEvent = exports.P2pConfirmRentAmountCtaClickedAnalyticsEvent = exports.P2pConfirmAddressCtaClickedAnalyticsEvent = exports.CardP2pViewedAnalyticsEvent = exports.CardP2pPropertyUpdateClickedAnalyticsEvent = exports.BannerP2pInviteSentClickedAnalyticsEvent = exports.BannerP2pInviteSentAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user clicks the 'Update property' button on the 'Action required to continue using Flex' screen in the Onboarding Flow
 */
var P2pUpdatePropertyCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('p2p_update_property_cta_clicked');
exports.P2pUpdatePropertyCtaClickedAnalyticsEvent = P2pUpdatePropertyCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks the 'See more details' button on the 'Action required to continue using Flex' screen in the Onboarding Flow
 */
var P2pUpdateRentCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('p2p_update_rent_cta_clicked');
exports.P2pUpdateRentCtaClickedAnalyticsEvent = P2pUpdateRentCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks the 'See more details' button on the 'Action required to continue using Flex' screen in the Onboarding Flow
 */
var P2pUpdateAddressCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('p2p_update_address_cta_clicked');
exports.P2pUpdateAddressCtaClickedAnalyticsEvent = P2pUpdateAddressCtaClickedAnalyticsEvent;
/**
 * Triggers when user views the 'Search for your property' screen in the Onboarding Flow
 */
var ScreenP2pConfirmAddressAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_p2p_confirm_address');
exports.ScreenP2pConfirmAddressAnalyticsEvent = ScreenP2pConfirmAddressAnalyticsEvent;
/**
 * Triggers when user clicks the 'Confirm' button on the 'Confirm your address' screen in the Onboarding Flow
 */
var P2pConfirmAddressCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('p2p_confirm_address_cta_clicked');
exports.P2pConfirmAddressCtaClickedAnalyticsEvent = P2pConfirmAddressCtaClickedAnalyticsEvent;
/**
 * Triggers when user views the 'Confirm your rent amount' screen in the Onboarding Flow
 */
var ScreenP2pConfirmRentAmountAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_p2p_confirm_rent_amount');
exports.ScreenP2pConfirmRentAmountAnalyticsEvent = ScreenP2pConfirmRentAmountAnalyticsEvent;
/**
 * Triggers when user clicks the 'Confirm' button on the 'Confirm your rent amount' screen in the Onboarding Flow
 */
var P2pConfirmRentAmountCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('p2p_confirm_rent_amount_cta_clicked');
exports.P2pConfirmRentAmountCtaClickedAnalyticsEvent = P2pConfirmRentAmountCtaClickedAnalyticsEvent;
/**
 * Triggers whenever customer returns to home screen and banner is present
 */
var BannerP2pInviteSentAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('banner_p2p_invite_sent');
exports.BannerP2pInviteSentAnalyticsEvent = BannerP2pInviteSentAnalyticsEvent;
/**
 * Triggers whenever customer clicks on banner to go back to relink flow
 */
var BannerP2pInviteSentClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('banner_p2p_invite_sent_clicked');
exports.BannerP2pInviteSentClickedAnalyticsEvent = BannerP2pInviteSentClickedAnalyticsEvent;
/**
 * Triggers whenever customer views the P2P card on the home screen card
 */
var CardP2pViewedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('card_p2p_viewed');
exports.CardP2pViewedAnalyticsEvent = CardP2pViewedAnalyticsEvent;
/**
 * Triggers whenever customer clicks on property update button on the home screen card
 */
var CardP2pPropertyUpdateClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('card_p2p_property_update_clicked');
exports.CardP2pPropertyUpdateClickedAnalyticsEvent = CardP2pPropertyUpdateClickedAnalyticsEvent;
